import axios from "../api"
import { getToken } from "../util/util"

export const getProducts = () =>
  axios
    .post("/products/getAll", null, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .then((res) => res.data)
